/**
 * NAD Collection List Section
 * Handles scroll animations for collection sliders
 */

export class NADCollectionList {
  private scrollObserver: IntersectionObserver | null = null;
  private initialized = false;
  
  constructor() {
    this.init();
  }
  
  private init(): void {
    this.setupScrollAnimation();
    this.initialized = true;
  }
  
  private setupScrollAnimation(): void {
    const collections = document.querySelectorAll<HTMLElement>('.nad-collection-list__collection');
    
    if (collections.length === 0) return;
    
    this.scrollObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('nad-collection-list__collection--visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );
    
    collections.forEach((collection) => {
      this.scrollObserver?.observe(collection);
    });
  }
  
  public destroy(): void {
    if (this.scrollObserver) {
      this.scrollObserver.disconnect();
      this.scrollObserver = null;
    }
    this.initialized = false;
  }
  
  // Static method to initialize all collection lists
  public static initializeAll(): NADCollectionList | null {
    if (document.querySelector('.nad-collection-list')) {
      return new NADCollectionList();
    }
    return null;
  }
}
